import { AfterViewInit, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PrimeNgModule } from '../../primeng.module';
import { CardModule } from 'primeng/card';
import { environment } from '../../../../environments/environment';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ApiService } from '../../../services/api.service';

export interface TableColumn{
  field: string;
  header: string;
  sortable?: boolean;
  width?: string;
  filterType?: 'text' | 'numeric' | 'date' | 'dropdown' | 'boolean';
  filterValues?: any[]; // For dropdown filter options
  format?: (value: any) => any; // For custom formatting
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  standalone: false,

})
export class DataTableComponent implements OnInit, OnChanges {
  @Input() title: string = 'Title';
  @Input() url: string = '';
  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() totalRecords: number = 0;
  @Input() loading: boolean = false;
  @Input() paginator: boolean = true;
  @Input() rows: number = 10;
  @Input() globalFilterFields: string[] = [];
  @Input() selectionMode: 'single' | 'multiple' | null = null;
  @Input() responsive: boolean = true;
  @Input() stripedRows: boolean = false;
  @Input() showGridlines: boolean = false;
  @Input() tableStyle: any = { width: '100%' };
  @Input() stateful: boolean = true;
  @Input() stateKey: string = 'data-table';
  @Input() scrollable: boolean = false;
  @Input() scrollHeight: string = '';
  @Input() tableClass: string = '';
  @Input() isDeletable: boolean = false;
  @Input() isEditable: boolean = false;
  @Input() isView: boolean = false;
  @Input() showAddButton: boolean = true; // default is true
  @Input() showActions: boolean = true; // default is true
  @Input() showSearch: boolean = true; // default is true
  @Input() additionalHeaderButtons: any[] = []; 
  @Input() showHeader: boolean = true; 
  @Input() showCheckbox: boolean = false;

  // Theme support
  @Input() currentTheme: string = 'aura-then-theme'; // Default theme
  @Input() isCardView: boolean = false;
  @Output() onRowSelect = new EventEmitter<any>();
  @Output() onRowUnselect = new EventEmitter<any>();
  @Output() onPage = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<any>();
  @Output() onFilter = new EventEmitter<any>();
  @Output() onRowClick = new EventEmitter<any>();
  @Output() onLazyLoad = new EventEmitter<any>();
  @Output() onAdd = new EventEmitter<any>();
  @Output() onPresentView = new EventEmitter<any>();
  @Output() onAdditionalButtonClick = new EventEmitter<any>();
  @Output() deleteEventRow = new EventEmitter<any>();
  @Output() editEventRow = new EventEmitter<any>();
  @Output() viewEventRow = new EventEmitter<any>();
  @Output() onSelectionChange = new EventEmitter<any[]>();
  @Input() rowsPerPage: number = 10;
  @Input() rowsPerPageOptions: number[] = [5, 10, 20, 50, 100];
  @Input() showFirstLastIcon: boolean = true;
  @Input() showPageLinks: boolean = true;
  @Input() showCurrentPageReport: boolean = true;
  @Input() showJumpToPageDropdown: boolean = false;
  @Input() editingRowId: number | null = null;

  totalCount: number = 0;
  selectedItems: any[] = [];
  currentRow: any;
  lazy=true
  // Mock data for the new template
  customers: any[] = [];
  cols: any[] = [];
  globalFields: string[] = [];
  apiUrl=environment.APIUrl
  @ViewChild('dt') table: TableModule;

  constructor(@Inject(DOCUMENT) public document: Document, private api: ApiService) { }

  ngOnInit(): void {
    this.customers = [...(this.data || [])];
    this.cols = this.columns;
    this.totalCount = this.totalRecords;
    this.globalFields = this.cols.map(col => col.field);
    console.log("checking",this.totalCount, this.totalRecords);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.customers = [...(this.data || [])];
    }
    if (changes['columns']) {
      this.cols = [...(this.columns || [])];
    }
    if (changes['totalRecords']) {
      this.totalCount = this.totalRecords || 0;
    }
    if (this.url && (!this.data || this.data.length === 0)) {
      this.apiCall();
    }
  }
  apiCall(){
    this.customers = [];
    this.totalCount = 0;
    const tempUrl = this.url + '?page=1';
    this.api.getAPI(tempUrl).subscribe((res: any) => {
      if(res?.results){
      this.customers = [...res.results];
      this.totalCount = res.count;
      }if(res?.data){
        this.customers = [...res.data];
        this.totalCount = res.count;
      }else{
        this.customers = [...res.results];
        this.totalCount = res.count;
      }
    });
  }
  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((o, key) => (o && o[key] !== undefined) ? o[key] : '', obj);
  }

  // Convert status string to valid PrimeNG Tag severity
  getSeverity(status: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
     const normalized = String(status || '').toLowerCase();
    // switch (status?.toLowerCase()) {
     switch (normalized) {
      case 'qualified':
        return 'success';
      case 'pending':
      case 'negotiation':
        return 'warning';
      case 'inactive':
      case 'unqualified':
        return 'danger';
      default:
        return 'info';
    }
  }

clear(table: any, searchInput?: HTMLInputElement): void {
  // Step 1: Clear the search input box
  this.searchText = '';
  this.lazy = true;
  // Step 2: Reset internal paginator tracking
  this.first = 0;

  // Step 4: Clear table filters and pagination
  if (table) {
    table.clear();     
    table.first = 0;  
  }
  this.apiCall();
}
apiClear(){
      
  this.searchText = '';
  this.lazy = true;
  this.apiCall();
}


  onRowSelectHandler(event: any): void {
    this.onRowSelect.emit(event);
  }

  onRowUnselectHandler(event: any): void {
    this.onRowUnselect.emit(event);
  }

  onRowClickHandler(event: any): void {
    this.onRowClick.emit(event);
  }

  onPageHandler(event: any): void {
    this.onPage.emit(event);
  }

  onSortHandler(event: any): void {
    this.onSort.emit(event);
  }

  onFilterHandler(event: any): void {
    this.onFilter.emit(event);
  }

  onLazyLoadHandler(event: any): void {
    this.onLazyLoad.emit(event);
  }

  getThemeClass(): string {
    // Check if we're in dark mode
    const isDarkMode = document.body.classList.contains('noir-theme') ||
      document.documentElement.classList.contains('noir-theme');
    return isDarkMode ? 'noir-theme' : 'aura-then-theme';
  }




@Output() onLazyLoadData = new EventEmitter<{ page: number; search?: string; filters?: any; sortField?: string; sortOrder?: number }>();
first = 0;
searchText: string = '';
columnFilters: any = {};

// loadDataLazy(event: any) {
//   this.first = event.first;
//   const page = event.first / event.rows + 1;

//   let searchTerm = this.searchText?.trim() || '';
//   const payload: any = { page };
  
//   if (searchTerm) {
//     payload.search = searchTerm;
//   }

//   // Add column filters
//   if (Object.keys(this.columnFilters).length > 0) {
//     payload.filters = this.columnFilters;
//   }

//   // Add sorting information
//   if (event.sortField) {
//     payload.sortField = event.sortField;
//     payload.sortOrder = event.sortOrder;
//   }

//   this.onLazyLoadData.emit(payload);
// }

loadDataLazy(event: any) {
  this.lazy = true;
  this.first = event.first;
  const page = event.first / event.rows + 1;

  const payload: any = { page, rows: event.rows };

  // Global search
  if (this.searchText?.trim()) {
    payload.search = this.searchText.trim();
  }

  // ✅ Column filters from event
  if (event.filters) {
    const filters: any = {};
    Object.keys(event.filters).forEach(field => {
      const filterMeta = event.filters[field];
      if (filterMeta?.value) {
        filters[field] = filterMeta.value;
      }
    });
    if (Object.keys(filters).length > 0) {
      payload.filters = filters;
    }
  }

  // Sorting
  if (event.sortField) {
    payload.sortField = event.sortField;
    payload.sortOrder = event.sortOrder;
  }
  this.apiCall();

  this.onLazyLoadData.emit(payload);
}



onEnterSearch(value: string) {
  this.lazy = false;
  this.searchText = value.trim();
  this.api.getAPI(this.url + '?search=' + this.searchText).subscribe((res: any) => {
    this.customers = res.data || res.results;
    this.totalCount = this.customers.length;
  });
  
}


onSearchInput(value: string) {
  this.searchText = value.trim();
  }
getColumnWidth(col: any): string {
  // Default widths based on column type or field
  if (col.type === 'link') return '100px';
  if (col.field === 'sequence') return '50px';
  if (col.field === 'status') return '120px';
  if (col.field === 'name') return '200px';
  if (col.field === 'total_mark') return '150px';
  if (col.field === 'cut_off') return '150px';
  if (col.field === 'sub_name') return '200px';
  if (col.field === 'description') return '300px';
  if (col.field === 'date') return '150px';
  // Add more specific cases as needed
  
  // Default width for other columns
  return '150px';
}

onPageChange(event: any): void {
  if(this.searchText){
    this.lazy = false;
    // this.onEnterSearch(this.searchText);
    return;
  }
  this.lazy = true;
  const rows=event.rows;
  const first=event.first;
  const page=first/rows+1;
  // let apiUrl=this.url+`?page=${page}&page_size=${rows}`;
  let apiUrl=this.url+`?page=${page}`;
  this.api.getAPI(apiUrl).subscribe((response: any) => {
    this.customers = [...response.results];
    this.totalCount=response?.count;
    
  });
}
  downloadFiles(files: any[]) {

  files.forEach(file => {

    const url = 'https://iima-api.ilizien-projects-cdf.in' + file.file_url;

    const link = document.createElement('a');
    link.href = url;
    link.download = file.file_name;
    link.target = '_blank';
    link.click();

  });

}

}
